import { DailyPuzzleGameSaveData } from '@mental-mint/shared-types';
import { CraftegoryLevelResult } from '../Data/types';

export const CRAFTEGORY_SAVE_VERSION = 2;

export interface CraftegoryLevelScore {
  levelId: string;
  isWon: boolean;
  gameMetadata: CraftegoryLevelResult;
}

export interface CraftegrySaveData extends DailyPuzzleGameSaveData<CraftegoryLevelResult> {}

export const DEFAULT_CRAFTEGORY_SAVE_DATA: CraftegrySaveData = {
  version: CRAFTEGORY_SAVE_VERSION,
  levelScores: {},
  bestStreak: 0,
  currentStreak: 0,
};
